const OrDivider = () => (
  <div className="text-gray-400 w-full text-center border-b leading-[0.1em]">
    <span className="bg-white px-4">or</span>
  </div>
)

export default OrDivider
